import {SET_POLICIES} from '../actions/PoliciesActions';
import initialState from './initialState';

export default (state = initialState.policies, action) => {
    const {type = '', payload} = action;

    switch (type) {
    case SET_POLICIES: {
        const {data} = payload;
        return data;
    }
    default:
        return state;
    }
};
